export default "__VITE_ASSET__e693920d__"